import type { ClientDto } from '@fos/shared/contracts/crm';
import { FileText, Lock } from 'lucide-react';
import { useAccess } from '../../../lib/useAccess';
import { Section } from '../../../ui/Section';
import { EmptyState } from '../../../ui/States';
import { OfferRows } from './OfferRows';

/**
 * Zakładka „Oferty” w profilu klienta (po „Wiedzy”): oferty klienta od najnowszej z „Nowa oferta”.
 * Klient widoczny tylko jako karta (tryb częściowy) nie pokazuje ofert — należą do całego klienta.
 */
export function ClientOffersTab({ client }: { client: ClientDto }) {
  const access = useAccess();
  if (!access.can('clients')) {
    return (
      <Section>
        <EmptyState icon={Lock} title="Brak dostępu do modułu Klienci" />
      </Section>
    );
  }
  if (client.partial) {
    return (
      <Section>
        <EmptyState
          icon={FileText}
          title="Oferty widzą osoby z dostępem do całego klienta"
          description="Masz dostęp tylko do wybranego projektu albo zasobu tego klienta."
        />
      </Section>
    );
  }
  const archived = client.status === 'archived' || client.archivedAt !== null;
  return <OfferRows clientId={client.id} allowAdd={!archived} />;
}
